import React, { useEffect, useState } from "react";
import "./InvestigatorsTabContent.css";
import "../../../../App";
import InfoCard from "../../../ui/InfoCard/InfoCard";
import AddCard from "../../../ui/AddCard/AddCard";
import { FaUser } from "react-icons/fa";
import NewInvestigator from "../../../study_member/NewInvestigator/NewInvestigator";
import ConfirmDeleteModal from "../../../ui/ConfirmDeleteModal/ConfirmDeleteModal";
import { study_membersService } from "../../../../service";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const InvestigatorsTabContent = ({ onShowInvesDetails }) => {
  const [investigators, setInvestigators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showNewInvestigator, setShowNewInvestigator] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedInvestigator, setSelectedInvestigator] = useState(null);
  const [refreshTick, setRefreshTick] = useState(0);

  const { studyId } = useParams();

  useEffect(() => {
    if (!studyId) return;

    let isMounted = true;

    (async () => {
      try {
        setLoading(true);
        setError("");
        const { data } = await study_membersService.listInvestigators(studyId);
        if (isMounted) setInvestigators(data);
      } catch (err) {
        console.error("Erreur lors du chargement des investigateurs:", err);
        if (isMounted)
          setError("Impossible de charger la liste des investigateurs.");
      } finally {
        if (isMounted) setLoading(false);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [studyId, refreshTick]);

  const handleRemoveInvestigator = async () => {
    if (!selectedInvestigator) return;

    try {
      await study_membersService.removeInvestigator(
        studyId,
        selectedInvestigator.id
      );
      toast.success(
        `${selectedInvestigator.first_name} ${selectedInvestigator.last_name} a été retiré avec succès.`
      );
      setShowConfirmModal(false);
      setSelectedInvestigator(null);
      setRefreshTick((t) => t + 1);
    } catch (err) {
      console.error("Erreur lors du retrait de l’investigateur:", err);
      const msg =
        err.response?.data?.detail ||
        "Une erreur est survenue lors du retrait.";
      toast.error(msg);
    }
  };

  const handleBack = (shouldRefresh = false) => {
    setShowNewInvestigator(false);
    if (shouldRefresh) setRefreshTick((t) => t + 1);
  };

  if (showNewInvestigator) {
    return (
      <NewInvestigator studyId={studyId} onBack={() => handleBack(true)} />
    );
  }

  // 🔑 Build a single array of items with explicit keys
  const renderItems = () => {
    const items = [];

    // Add new investigator card
    items.push(
      <div
        className="col-12 col-sm-6 col-md-4 col-lg-3 add-invest"
        key="add-investigator"
      >
        <AddCard
          title="Nouveau investigateur"
          onADD={() => setShowNewInvestigator(true)}
        />
      </div>
    );

    // Error message
    if (error) {
      items.push(
        <div
          className="alert alert-danger mt-3 col-12"
          key="error-message"
        >
          {error}
        </div>
      );
    }

    // Loading / Empty / List
    if (loading) {
      items.push(
        <div className="col-12" key="loading-placeholder">
          {/* you can put a spinner here if you want */}
        </div>
      );
    } else if (investigators.length === 0) {
      items.push(
        <p className="text-center mt-4 col-12" key="empty-state">
          {/* Aucun investigateur pour le moment. */}
        </p>
      );
    } else {
      investigators.forEach((inv) => {
        items.push(
          <div
            className="col-12 col-sm-6 col-md-4 col-lg-3"
            key={inv.id}
          >
            <InfoCard
              title={inv.professional_address}
              count={inv.last_name}
              unit={inv.first_name}
              Icon={FaUser}
              options={[
                {
                  label: "Retirer",
                  onClick: () => {
                    setSelectedInvestigator(inv);
                    setShowConfirmModal(true);
                  },
                },
              ]}
              actionType="Voir les détails"
              onClick={() => onShowInvesDetails(inv.id)}
              onStatsClick={() => onShowInvesDetails(inv.id)}
            />
          </div>
        );
      });
    }

    return items;
  };

  return (
    <div className="overflow-y-auto px-0" style={{ height: "100%" }}>
      <div className="container-fluid">
        <div className="row g-3">
          {renderItems()}
        </div>
      </div>

      {/* Confirmation modal */}
      <ConfirmDeleteModal
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={handleRemoveInvestigator}
        studyName={
          selectedInvestigator
            ? `${selectedInvestigator.first_name} ${selectedInvestigator.last_name}`
            : ""
        }
        type="l’investigateur"
      />
    </div>
  );
};

export default InvestigatorsTabContent;
